export const servicesAllKey = 'servicesAll';
export const servicesAllListKey = 'servicesAllList';
export const getServicesKey = 'getServices';
export const getServicesListKey = 'getServicesList';
export const deleteServicesKey = 'deleteServices';
export const editServicesKey = 'editServices';
export const updateServicesKey = 'updateServices';
export const addServicesKey = 'addServices';
